import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import getSigchartList from './actions/getSigchartList'
import getSigchart from './actions/getSigchart'
import selectDocument from './actions/selectDocument'
import Sigcharts from './components/index'
import resetError from "shared/errorHandler/actions/resetError";

const mapStateToProps = (state) => {
    return ({
        data: state.sigcharts.data,
        blobUrl: state.sigcharts.blobUrl,
        isLoading: state.sigcharts.isLoading,
        selectedIds: state.sigcharts.selectedIds,
        loadingIds: state.sigcharts.loadingIds,
        error: state.error.message,
        username: state.user.username
    })
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        getSigchartList,
        getSigchart,
        selectDocument,
        resetError
    }, dispatch)
})

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Sigcharts))



// WEBPACK FOOTER //
// ./src/screens/sigcharts/index.js